import React from "react";
import { Input as SemanticInput } from "semantic-ui-react";
import "./HuiInput.scss";
import PropTypes from "prop-types";

export const HuiInput = ({
  className,
  bigger = false,
  disabled = false,
  error = false,
  ...props
}) => {
  // const inputIcon = error && icon === undefined ? 'exclamation triangle' : icon;
  return (
    <SemanticInput
      className={`hireart-ds-input ${bigger ? "alternative" : ""} ${className}`}
      disabled={disabled}
      error={error}
      {...props}
    />
  );
};

HuiInput.propTypes = {
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  bigger: PropTypes.bool,
};

